module.exports = __webpack_public_path__ + "assets/9e5c896a805decc72f78016d02ca71c8.mp4";